export const COUNTRY_CODE_MAP = {
  IN: {
    country: "India",
    ISOCode: "IN",
    countryCode: "+91",
    length: 10,
  },
  US: {
    country: "United States",
    ISOCode: "US",
    countryCode: "+1",
    length: 10,
  },
  GB: {
    country: "United Kingdom",
    ISOCode: "GB",
    countryCode: "+44",
    length: 10,
  },
  AU: {
    country: "Australia",
    ISOCode: "AU",
    countryCode: "+61",
    length: 9,
  },
  AE: {
    country: "United Arab Emirates",
    ISOCode: "AE",
    countryCode: "+971",
    length: 9,
  },
  SA: {
    country: "Saudi Arabia",
    ISOCode: "SA",
    countryCode: "+966",
    length: 9,
  },
  SG: {
    country: "Singapore",
    ISOCode: "SG",
    countryCode: "+65",
    length: 8,
  },
  MY: {
    country: "Malaysia",
    ISOCode: "MY",
    countryCode: "+60",
    length: 9,
  },
  NZ: {
    country: "New Zealand",
    ISOCode: "NZ",
    countryCode: "+64",
    length: 9,
  },
  ZA: {
    country: "South Africa",
    ISOCode: "ZA",
    countryCode: "+27",
    length: 9,
  },
  FR: {
    country: "France",
    ISOCode: "FR",
    countryCode: "+33",
    length: 9,
  },
  DE: {
    country: "Germany",
    ISOCode: "DE",
    countryCode: "+49",
    length: 10,
  },
  IT: {
    country: "Italy",
    ISOCode: "IT",
    countryCode: "+39",
    length: 10,
  },
  ES: {
    country: "Spain",
    ISOCode: "ES",
    countryCode: "+34",
    length: 9,
  },
  NL: {
    country: "Netherlands",
    ISOCode: "NL",
    countryCode: "+31",
    length: 9,
  },
  SE: {
    country: "Sweden",
    ISOCode: "SE",
    countryCode: "+46",
    length: 9,
  },
  NO: {
    country: "Norway",
    ISOCode: "NO",
    countryCode: "+47",
    length: 8,
  },
  DK: {
    country: "Denmark",
    ISOCode: "DK",
    countryCode: "+45",
    length: 8,
  },
  FI: {
    country: "Finland",
    ISOCode: "FI",
    countryCode: "+358",
    length: 9,
  },
  JP: {
    country: "Japan",
    ISOCode: "JP",
    countryCode: "+81",
    length: 10,
  },
  KR: {
    country: "South Korea",
    ISOCode: "KR",
    countryCode: "+82",
    length: 10,
  },
  CN: {
    country: "China",
    ISOCode: "CN",
    countryCode: "+86",
    length: 11,
  },
  HK: {
    country: "Hong Kong",
    ISOCode: "HK",
    countryCode: "+852",
    length: 8,
  },
  TH: {
    country: "Thailand",
    ISOCode: "TH",
    countryCode: "+66",
    length: 9,
  },
  ID: {
    country: "Indonesia",
    ISOCode: "ID",
    countryCode: "+62",
    length: 10,
  },
  PH: {
    country: "Philippines",
    ISOCode: "PH",
    countryCode: "+63",
    length: 10,
  },
  PK: {
    country: "Pakistan",
    ISOCode: "PK",
    countryCode: "+92",
    length: 10,
  },
  BD: {
    country: "Bangladesh",
    ISOCode: "BD",
    countryCode: "+880",
    length: 10,
  },
  LK: {
    country: "Sri Lanka",
    ISOCode: "LK",
    countryCode: "+94",
    length: 9,
  },
  NP: {
    country: "Nepal",
    ISOCode: "NP",
    countryCode: "+977",
    length: 10,
  },
  BR: {
    country: "Brazil",
    ISOCode: "BR",
    countryCode: "+55",
    length: 11,
  },
  MX: {
    country: "Mexico",
    ISOCode: "MX",
    countryCode: "+52",
    length: 10,
  },
  AR: {
    country: "Argentina",
    ISOCode: "AR",
    countryCode: "+54",
    length: 10,
  },
  CL: {
    country: "Chile",
    ISOCode: "CL",
    countryCode: "+56",
    length: 9,
  },
  CO: {
    country: "Colombia",
    ISOCode: "CO",
    countryCode: "+57",
    length: 10,
  },
  TR: {
    country: "Turkey",
    ISOCode: "TR",
    countryCode: "+90",
    length: 10,
  },
  RU: {
    country: "Russia",
    ISOCode: "RU",
    countryCode: "+7",
    length: 10,
  },
};

export const COUNTRY_CODE_LIST = Object.values(COUNTRY_CODE_MAP);

export const COUNTRY_LIST = COUNTRY_CODE_LIST.map(c => ({
  label: c.country,
}));


export const splitE164 = (rawPhone) => {
  if (!rawPhone || typeof rawPhone !== "string") {
    return { phoneCountryCode: "", phone: "" };
  }

  let normalized = rawPhone.trim().replace(/(?!^\+)\D/g, "");

  if (!normalized.startsWith("+")) {
    return { phoneCountryCode: "", phone: normalized };
  }

  const sortedEntries = COUNTRY_CODE_LIST.slice().sort(
    (a, b) => b.countryCode.length - a.countryCode.length
  );

  for (const entry of sortedEntries) {
    const { countryCode, length } = entry;
    if (normalized.startsWith(countryCode)) {
      const subscriber = normalized.slice(countryCode.length);
      if (/^\d+$/.test(subscriber) && subscriber.length === length) {
        return { phoneCountryCode: countryCode, phone: subscriber };
      }
    }
  }

  for (const entry of sortedEntries) {
    const { countryCode } = entry;
    if (normalized.startsWith(countryCode)) {
      const subscriber = normalized.slice(countryCode.length);
      if (/^\d+$/.test(subscriber)) {
        return { phoneCountryCode: countryCode, phone: subscriber };
      }
    }
  }

  return { phoneCountryCode: "", phone: normalized.replace(/^\+/, "") };
};
